import { registrationAction } from '@store/slices/registration/actions/registration';
import { createSlice } from '@reduxjs/toolkit';
import { ALM_COOKIE_KEY, VIAX_COOKIE_KEY } from '@config/constants';
import {
  setCookie, SiteConfig,
  onCreateAccountSuccess,
  onCreateAccountFailure,
} from '@utils';
import { ResponseStatus } from '@requests/registration';
import { HttpStatusCode } from '@types';
import { TurnstileCaptchaService } from '@services';

interface RegistrationState {
  isLoading: boolean;
  error: boolean;
  errorCode?: HttpStatusCode;
}

const initialState: RegistrationState = {
  isLoading: false,
  error: false,
  errorCode: undefined,
};

export const registrationSlice = createSlice({
  name: 'registration',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(registrationAction.pending, (state) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(registrationAction.fulfilled, (state, { payload: { wEcomRegistration, redirectUrl } }) => {
        const { status, data, errors } = wEcomRegistration.result;
        state.isLoading = false;

        if (status === ResponseStatus.OK) {
          setCookie(ALM_COOKIE_KEY, data?.almToken);
          setCookie(VIAX_COOKIE_KEY, data?.viaxToken);
          onCreateAccountSuccess();

          window.location.href = redirectUrl || SiteConfig.buildContinueShoppingUrl();
        }

        if (status === ResponseStatus.ERROR) {
          state.error = true;
          state.errorCode = errors?.[0].code;
          TurnstileCaptchaService.reset();
          onCreateAccountFailure(
            errors?.[0]?.code || 'unknown',
            errors?.[0]?.message || 'Registration failed',
          );
        }
      })
      .addCase(registrationAction.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
        state.errorCode = HttpStatusCode.BAD_REQUEST;
        TurnstileCaptchaService.reset();
        onCreateAccountFailure(
          String(HttpStatusCode.BAD_REQUEST),
          'Registration request failed',
        );
      });
  },
});

export const registrationReducer = registrationSlice.reducer;
